/* eslint-disable react/prop-types */
/** @jsx createElement */
// noinspection ES6UnusedImports
import { createElement } from '../../jsx';
import InputText from './InputText';

const TransferContact = function ({ contactType, userDetails, translations }) {
  const {
    messageTypeContactMessagePhone,
    messageTypeContactPlaceholderPhone,
    messageTypeContactMessageEmail,
    messageTypeContactPlaceholderEmail,
  } = translations;
  return (
    [
      (contactType === 'phone' || contactType === 'any')
        ? (
          <InputText
            id="phone"
            name={messageTypeContactMessagePhone}
            type="tel"
            defaultValue={userDetails?.phone}
            placeholder={messageTypeContactPlaceholderPhone}
            minLength={5}
            required
          />
        )
        : undefined,
      (contactType === 'email' || contactType === 'any')
        ? (
          <InputText
            id="email"
            name={messageTypeContactMessageEmail}
            type="email"
            defaultValue={userDetails?.email}
            placeholder={messageTypeContactPlaceholderEmail}
            required
          />
        )
        : undefined,
    ].filter((element) => !!element)
  );
};

export default TransferContact;
